import { useState, useEffect, useCallback } from "react";
import { useSearchParams } from "react-router-dom";

export function useSearchQuery(paramKey: string = "q") {
  const [searchParams, setSearchParams] = useSearchParams();
  const getParamVal = useCallback(() => {
    return (
      searchParams.get(paramKey) ??
      (paramKey === "q" ? searchParams.get("search") : null) ??
      ""
    );
  }, [searchParams, paramKey]);

  const [query, setQuery] = useState<string>(getParamVal);

  useEffect(() => {
    const currentVal = getParamVal();
    if (currentVal !== query) {
      setQuery(currentVal);
    }
  }, [getParamVal, query]);

  const updateQuery = useCallback(
    (val: string) => {
      setQuery(val);
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          if (val.trim()) {
            next.set(paramKey, val);
          } else {
            next.delete(paramKey);
            if (paramKey === "q") {
              next.delete("search");
            }
          }
          return next;
        },
        { replace: true }
      );
    },
    [paramKey, setSearchParams]
  );

  return [query, updateQuery] as const;
}
